import { useState } from "react";
import "./style.css";

interface Props {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  className?: string;
}

const InputImage = ({ value }: Props) => {
  const [imagePreview, setImagePreview] = useState<any>(value);

  const handleUpload = (e: any) => {
    const reader = new FileReader();
    reader.onload = () => {
      setImagePreview(reader.result as string);
    };
    reader.readAsDataURL(e.target.files ? e.target.files[0] : new Blob());
  };

  return (
    <div className="f-image-container">
      <div className="f-image-preview">
        {imagePreview && <img src={imagePreview} width={300} height={200} />}
      </div>

      <div className="f-image-buttons">
        <button className="f-image-button f-image-button-upload">
          <input type="file" accept="image/*" onChange={(e) => handleUpload(e)} className="f-image-file-input" />
          Escolher Foto
        </button>
        <button className="f-image-button f-image-button-remove" onClick={() => setImagePreview(undefined)}>
          Remover
        </button>
      </div>
    </div>
  );
};

export default InputImage;
